import React, { createContext, useState, useContext, useEffect } from "react";
import { useAuthContext } from "./AuthContext";
// Socket.io disabled - not needed for time tracker
// import socket from "../socket";
// import AcceptOrderModal from "../components/AcceptOrderModal";
// import AudioPlayer from "../components/AudioPlayer";

export const AppStateContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");
  const [loading, setLoading] = useState(true);
  const { userProfile } = useAuthContext();

  // Socket.io related state - disabled
  // const socketRef = useRef(null);
  // const [selectedOrder, setSelectedOrder] = useState();
  // const [modal, showModal] = useState(false);
  // const [playAudio, setPlayAudio] = useState(false);

  const [restaurant, setRestaurant] = useState({
    restaurant: "Restaurant",
    rating: 0,
    review: 0,
  });

  const [country, setCountry] = useState({
    country_id: undefined,
    currency: undefined,
    data: undefined,
  });


  useEffect(() => {
    if (country.country_id == "646b2e0f46865f1f65565346") {
      console.log("Import Css");
      import("../assets/styles/rtl.css");
    } else {
      console.log(" remove Import Css");
    }
  }, [country.country_id]);


  useEffect(() => {
    setLoading(true);
    let lang = localStorage.getItem("languageSet");
    lang = lang ? lang : "en";

    if (lang == "ar") {
      console.log("Import Css");
      import("../assets/styles/rtl.css");
    } else {
      import("../assets/styles/main.css");
    }

    setTimeout(() => setLoading(false), 200);
    setLanguage(lang);
  }, []);

  // Socket.io disabled for now - not needed for time tracker
  // useEffect(() => {
  //   if (!userProfile) return
  //   let reconnectAttempts = 0;
  //   const maxReconnectAttempts = 150;
  //   const reconnectInterval = 1000;

  //   const connectSocket = () => {
  //     if (socketRef.current && socketRef.current.connected) {
  //       console.log('Socket already connected.');
  //       return;
  //     }

  //     const token = localStorage.getItem('token')
  //     socketRef.current = socket(token);

  //     socketRef.current.on('connect', () => {
  //       console.log('Connection established');
  //       reconnectAttempts = 0;
  //     })

  //     socketRef.current.on('disconnect', () => {
  //       console.log('Connection is lost');
  //       if (reconnectAttempts < maxReconnectAttempts) {
  //         reconnectAttempts++;
  //         console.log(`Attempting to reconnect (attempt ${reconnectAttempts})...`);
  //         setTimeout(connectSocket, reconnectInterval);
  //       } else {
  //         console.log('Max reconnect attempts reached. Disconnecting socket.');
  //         socketRef.current.disconnect();
  //       }
  //     })
  //   }

  //   connectSocket()

  //   const intervalId = setInterval(() => {
  //     if (!socketRef.current || !socketRef.current.connected) {
  //       connectSocket();
  //     }
  //   }, 3000);

  //   return () => {
  //     clearInterval(intervalId);
  //     if (socketRef.current) {
  //       console.log("Disconnect called");
  //       socketRef.current.disconnect();
  //     }
  //   };
  // }, [socketRef, userProfile])

  // useEffect(() => {
  //   if (!socketRef.current) return

  //   socketRef.current.on('newOrder', (data) => {
  //     console.log(data, "NEW_ORDER")

  //     if (data.data.is_company_order) return

  //     setSelectedOrder(data.data)
  //     setPlayAudio(true)

  //     setTimeout(()=>setPlayAudio(false),10000)
  //     showModal(true) 
     
  //   })
  // }, [socketRef, userProfile])


  return (
    <AppStateContext.Provider
      value={{
        restaurant,
        setRestaurant,
        setCountry,
        language,
        country,

      }}
    >
      {children}
      {/* Socket.io modals disabled - not needed for time tracker */}
      {/* {modal && selectedOrder && (
        <AcceptOrderModal
          section={"Home"}
          show={modal}
          hide={() => {
            showModal(false);
          }}
          order={selectedOrder}
          playAudio={playAudio}
          refresh={() => {}}
        >
          <AudioPlayer />
        </AcceptOrderModal>
      )} */}
    </AppStateContext.Provider>
  );
};
export const useAppContext = () => {
  return useContext(AppStateContext);
};
